import React from 'react';
import { useDispatch } from 'react-redux';
import { addToWatchlist } from '../../redux/actions/movieActions';
import './MovieDetailComponent.scss';
import { FaRegCalendarAlt } from 'react-icons/fa';
import { AiFillStar } from 'react-icons/ai';
import { RiBookmark3Fill } from 'react-icons/ri';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import fullDate from '../DateFunction';
import rating from '../RatingFunctiion';
import ReactPlayer from "react-player"

const MovieDetailComponent = ({ movieDet, videoKey }) => {

    const dispatch = useDispatch();

    return (
        <div className="movie-detail">
            {
                Object.keys(movieDet).length === 0 ? (
                    <LoadingSpinner />
                )
                : (
                    <>
                        <div className="movie-detail-hero">
                            <img src={(`https://www.themoviedb.org/t/p/original/${movieDet.backdrop_path}`)} alt="Movie Backdrop" className="movie-detail-bd" />
                            <div className="main-box-img-overlay"></div>
                            <div className="movie-detail-img-container">
                                <img src={(`https://www.themoviedb.org/t/p/original/${movieDet.poster_path}`)} alt="" className="movie-detail-img" />
                            </div>
                        </div>
                        <div className="movie-detail-info-container">
                            <h1 className="movie-title">{movieDet.title}</h1>
                            <i className="tagline">{movieDet.tagline}</i>
                            <div className="section-break">
                                <h3 className="details-header">GENRES</h3>
                                <ul className="movie-genres">
                                    {
                                        movieDet.genres.map(genre => (
                                            <li className="movie-genre" key={genre.id}>{genre.name}</li>
                                        ))
                                    }
                                </ul>
                            </div>
                            <div className="section-break">
                                <h3 className="details-header">OVERVIEW</h3>
                                <p className="movie-plot">{movieDet.overview}</p>
                            </div>
                            <div className="section-break">
                                <h3 className="details-header">RELEASE DATE</h3>
                                <p className="details-date"><FaRegCalendarAlt /> {fullDate(movieDet.release_date)}</p>  
                            </div>
                            <div className="section-break-nb">
                                <h3 className="details-header">RATING</h3>
                                <p className="details-rating">{rating(movieDet.vote_average)} <AiFillStar /></p>  
                            </div>
                            <div className="movie-trailer-container">
                                    <ReactPlayer className="movie-trailer"
                                        url={(`https://www.youtube.com/watch?v=${videoKey}`)}
                                        controls='true'
                                    />
                            </div>
                            <div className="movie-watchlist-btn" onClick={() => dispatch(addToWatchlist(movieDet))}><RiBookmark3Fill /> Add to watchlist</div>
                        </div>
                    </>
                    )
            }            
        </div>
    )
}

export default MovieDetailComponent
